import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';

/**
 * Generated class for the UssdTransactionsPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-ussd-transactions',
  templateUrl: 'ussd-transactions.html',
})
export class UssdTransactionsPage {

  constructor(public navCtrl: NavController, public navParams: NavParams) {
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad UssdTransactionsPage');
  }

}



// WEBPACK FOOTER //
// ./src/pages/ussd-transactions/ussd-transactions.ts